import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { Fancybox } from "@fancyapps/ui";
import { Modal } from "bootstrap";

import '../components/axios.js';
import Cookie from '../../../../dev/js/components/cookie.js';
import initPrototypes from '../components/prototypes.js';
import { getPublicUrl, detectLanguageParameter } from '../components/utils.js';
import AuthService from '../services/auth-service.js';
import ReCaptchaService from '../services/recaptcha-service.js';
import LikeService from '../services/like-service.js';

window.dataLayer = window.dataLayer || [];
window.Cookie = Cookie;
initPrototypes();

class Reviewer {
	constructor() {
		window.authService = this.authService = new AuthService();
		this.authService.init();
		window.reCaptchaService = this.reCaptchaService = new ReCaptchaService();
		this.reCaptchaService.init(); // TODO: it can be deleted after public.js isn't used anymore
		window.likeService = this.likeService = new LikeService();

        this.page = 1;
		this.linkPublicId = this.getLinkPublicId();
        this.confirmDialog = document.getElementById('delete-confirm-dialog');
        this.confirmModal = new Modal(this.confirmDialog);
        this.box = document.getElementById('primary');

        this.bindEvents();
        this.checkDeletable();
		this.formatReviews(this.box);

		Fancybox.bind("[data-fancybox]");
	}

	bindEvents() {
        document.addEventListener('click', (event) => {
            if (event.target.matches('.btn-delete')) {
                this.handleDeleteClick(event);
            } else if (event.target.matches('.btn-cancel-delete')) {
                this.handleCancelDelete(event);
            } else if (event.target.matches('#next-button')) {
                this.handleNextButtonClick(event);
            }
        });

		this.likeService.on('review-liked', (data) => {
			console.log('Review liked:', data);
			const likeContainer = document.querySelector('.hero-block .ti-review-likes .value');
			const totalLikes = parseInt(likeContainer.textContent);
			likeContainer.textContent = totalLikes + data.change;
		});
    }

	handleDeleteClick(event) {
        event.preventDefault();
        const btn = event.target;
        btn.classList.add('disabled');

        this.confirmDialog.querySelector('.btn-confirm-delete').href = btn.dataset.deleteUrl;
        this.confirmModal.show();

        this.confirmDialog.addEventListener('hidden.bs.modal', () => {
            btn.classList.remove('disabled');
        }, { once: true });
    }

    handleCancelDelete(event) {
        event.preventDefault();
        // this.confirmDialog.classList.remove('show');
        this.confirmModal.hide();
    }

	handleNextButtonClick(event) {
        event.preventDefault();
        const a = event.target.querySelector('a');
        if (a.classList.contains('loading')) {
            return false;
        }
        a.classList.add('loading');
        this.page++;
        this.getReviews(() => {
            a.classList.remove('loading');
        });
    }

    getLinkPublicId() {
        const path = location.pathname;
		const match = path.match(/\/reviewer\/([^/?]+)/);
		return match && match[1];
    }

    checkDeletable() {
        if (authService.retrievePublicId() === this.linkPublicId) {
            document.querySelectorAll('.deletable:has(button.btn-delete)').forEach(el => el.classList.remove('d-none'));
        } else {
            authService.on('closed', () => {
                if (authService.retrievePublicId() === this.linkPublicId) {
                    document.querySelectorAll('.deletable:has(button.btn-delete)').forEach(el => el.classList.remove('d-none'));
                }
            });
        }
    }

    formatReviews(container = document.body) {
        container.querySelectorAll('.ti-review-content').forEach(content => {
            content.TI_format().TI_shorten({
                'showLines': 30,
                'lessText': '<i class="ri-arrow-up-s-line" aria-hidden="true"></i> ' + document.body.dataset.lessText,
                'moreText': '<i class="ri-arrow-down-s-line" aria-hidden="true"></i> ' + document.body.dataset.moreText
            });
        });
    }

    getReviews(callback) {
        if (this.page < 1) {
            this.page = 1;
        }

        const list = document.querySelector('.reviews');
        let url = `${getPublicUrl()}/api/reviewer/${this.linkPublicId}`;
        const lang = detectLanguageParameter();
        if (lang) {
            url += `/${lang}`;
        }

        reCaptchaService.runWithCaptcha(
            "reviewer_review_list",
            (token, withCheckbox = false) => {
                return axios.post(url, {
                    page: this.page,
                    recaptcha_token: token,
                    recaptcha_checkbox: withCheckbox,
                })
                .then((response) => {
                    console.log("reviewer_review_list", response);
                    const reviews = document.createElement('div');
                    reviews.innerHTML = response.data.html;
                    reviews.style.display = 'none';
                    list.appendChild(reviews);
                    reviews.style.display = 'block';

                    if (!response.data['next-page']) {
                        document.querySelector('.pagination').style.display = 'none';
                    }

                    this.formatReviews(reviews);
                    this.checkDeletable();

                    if (callback) {
                        callback();
                    }
                })
                .catch((error) => {
                    console.error("reviewer_review_list", error);
                    if (callback) {
                        callback();
                    }
                });
            }
        );
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new Reviewer();
});